import React, { useState } from "react";
import { Search } from "react-feather";
import cx from "classnames";

interface Props {
  formAction: string;
  paramName: string;
  lang: {
    searchPlaceholder: string;
    searchButtonAction: string;
  };
}

export const MobileSearch: React.FC<Props> = props => {
  const [value, setValue] = useState("");
  const [focused, setFocused] = useState(false);

  return (
    <form
      method="get"
      action={props.formAction}
      className={cx("SiteNavigation__Search", {
        "SiteNavigation__Search--activated": value.length > 0 || focused
      })}
    >
      <Search className="SiteNavigation__Search__Icon" />
      <input
        name={props.paramName}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={props.lang.searchPlaceholder}
        value={value}
        onChange={evt => setValue(evt.target.value)}
      />

      {value.length > 0 && (
        <button type="submit" className="SiteNavigation__Search__Submit">
          <span>{props.lang.searchButtonAction}</span>
        </button>
      )}
    </form>
  );
};
